import React, { useEffect, useState } from "react";
import { Table, Typography, message, Spin, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../Components/Constant";
import ApiService from "../Components/apiService";

const { Title } = Typography;

const ConnectorsView = () => {
  const [connectors, setConnectors] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchConnectors();
  }, []);

  const fetchConnectors = async () => {
    setLoading(true);
    try {
      const connectorService = new ApiService(
        `${BASE_URL}/connectors`, // Rails endpoint
        { "Content-Type": "application/json" },
        "GET"
      );
      const response = await connectorService.makeCall();
      console.log('Fetched connectors:', response);
      // Normalize response
      const list =
        response?.connectors?.map((c) => ({
          id: c._id, // Rails uses _id (Mongoid)
          name: c.name,
          systemType: c.system_type, // map system_type → systemType
          description: c.description,
        })) || [];

      setConnectors(list);
    } catch (err) {
      console.error("Error fetching connectors:", err);
      message.error("Failed to fetch connectors");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <a onClick={() => navigate(`/setup/SystemConnectors/${record.id}`)}>{text}</a>
      ),
    },
    {
      title: "System Type",
      dataIndex: "systemType",
      key: "systemType",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <Card bordered={true} style={{ borderRadius: 8 }}>
        <Title level={3}>Connectors</Title>
        <Spin spinning={loading}>
          <Table
            rowKey="id"
            dataSource={connectors}
            columns={columns}
            bordered
            pagination={{ pageSize: 10 }}
          />
        </Spin>
      </Card>
    </div>
  );
};

export default ConnectorsView;
